import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Tooltip,
} from "recharts";
import { Chart, useChart } from "@chakra-ui/charts";
import { Box, Text } from "@chakra-ui/react";
import { SubjectPerformance } from "../../../services/Dtos";
import { getShortName } from "../../../services/Utils";
import useThemeColors from "../../../hooks/useThemeColors";

interface Props {
  subjectData: SubjectPerformance[] | null;
}
const TopSubjectsChart = ({ subjectData }: Props) => {
  const colors = useThemeColors();

  // Custom Tooltip Component
  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <Box
          bg={colors.background.tertiary}
          color={colors.text.primary}
          p={4}
          borderRadius="md"
          boxShadow="md"
          borderWidth={1}
          fontSize={"sm"}
        >
          <Text fontWeight="bold">{label}</Text>
          <Text>{`Performance: ${payload[0].value}`}</Text>
        </Box>
      );
    }

    return null;
  };

  const chart = useChart({
    data: subjectData || [],
  });

  return (
    <Chart.Root  chart={chart} >
      <RadarChart data={chart.data}>
        {/* Define gradient */}
        <defs>
          <linearGradient id="colorSubjects" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#C2C0FF" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#A45BE6" stopOpacity={0.8} />
          </linearGradient>
        </defs>

        <PolarGrid />
        <PolarAngleAxis
          dataKey="subject"
          fontSize={"12px"}
          tickFormatter={(value) => getShortName(value)}
        />
        <PolarRadiusAxis angle={55} domain={[0, 100]} fontSize={"12px"} />
        <Radar
          name="Performance"
          dataKey="score"
          stroke="#5A57FF"
          fill="url(#colorSubjects)"
          fillOpacity={0.8}
        />
        <Tooltip
          cursor={{ fill: chart.color("bg.muted") }}
          content={<CustomTooltip />}
          animationDuration={100}
        />
      </RadarChart>
    </Chart.Root>
  );
};

export default TopSubjectsChart;
